import cloneDeep from 'lodash/cloneDeep';
import takeRight from 'lodash/takeRight';

import pick from 'lodash/pick';
import {modify} from 'mythil/object';
import forOwn from 'lodash/forOwn';
import reduceUi from './reduceUi';
import reduceRouter from './reduceRouter';
import {CHANGE_APP_PAGE, CHANGE_DIALOG_PAGE, CHANGE_APP_PAGE_ACTION, CHANGE_PAGE, SET_CREDENTIALS} from "~/actions/actions";
import {reduceAuth, reduceAuthState} from "~/rx/authenticate";
import {reducePassword} from "~/rx/password";
import {reduceLogout, reduceLogoutState} from "~/rx/logout";
import {reduceModelCacheStatus, reduceModelConfigs} from "~/rx/modelConfigs"
import {reduceItemDeleteState} from "~/rx/model/deleteItem";
import {reduceItemCustomActionState} from "~/rx/model/itemCustomAction";
import {reduceCustomActionState} from "~/rx/model/customAction";
import {reduceItemSaveState} from "~/rx/model/saveItem";
import reduceHelp from "~/reducers/reduceHelp";
import { defaultPageState } from '../config';
import { reduceFilteredViews, reduceModelConfgsSettings, reduceFilteredViewsRoute } from './reduceFilteredViews';
import { reduceSubviews } from './reduceSubviews';
import { reduceRelationshipField } from './reduceRelationshipField';

const ROUTER_LOCATION_CHANGED = 'ROUTER_LOCATION_CHANGED';

export function createReduce(reducers) {
    return (state, action) => {
        const previousState = state;

        // let t1 = performance.now();
        // console.log('[PENDING] '+action.type, action);
        // console.log('[PENDING]', state);

        state = modify(state, 'lastAction', action);
        state = modify(state, 'authResult', (authResult) => (reduceAuth(authResult, action)));
        state = modify(state, 'resetPassword', (passwordResult) => (reducePassword(passwordResult, action)));
        state = modify(state, 'logoutResult', (logoutResult) => reduceLogout(logoutResult, action));
        state = modify(state, 'help', (help) => reduceHelp(help, action));
        state = modify(state, 'modelCacheStatus', (modelCacheStatus) => reduceModelCacheStatus(modelCacheStatus, action));

        state = reduceItemSaveState(state, action);
        state = reduceItemDeleteState(state, action);
        state = reduceItemCustomActionState(state, action);
        state = reduceCustomActionState(state, action);
        state = reduceItemSaveState(state, action);
        state = reduceAuthState(state, action);
        state = reduceLogoutState(state, action);

        switch(action.type) {
            case CHANGE_PAGE:
                return { ...state, page: action.page };
            case CHANGE_APP_PAGE:
                state = {
                    ...state,
                    appPage: action.appPage,
                    appPages: cloneDeep(defaultPageState),
                };

                state = { ...state, appPage: action.appPage };
                break;
            case CHANGE_APP_PAGE_ACTION: 
                state = {
                    ...state,
                    appPageAction: action.action ? action.data : null,
                };
                break;
            case CHANGE_DIALOG_PAGE:
                state = {
                    ...state,
                    dialogPage: action.dialogPage,
                };

                break;
            case SET_CREDENTIALS:
                state = modify(state, 'credentials', pick(action, ['username', 'password']))
                break;
            
            case ROUTER_LOCATION_CHANGED:{
                state = {
                    ...state,
                    locationHistory: [
                        ...takeRight(state.locationHistory, 5),
                        action.payload
                    ]
                };
                break;
            }
        }

        state = modify(state, "models", (models) => reduceModelConfigs(models, action));
        state = modify(state, "ui", reduceUi(state, action));
        state = reduceModelConfgsSettings(state, action);
        state = modify(state, "ui", (loadedModels) => reduceFilteredViews(loadedModels, action, state) )
        state = reduceSubviews(state, action);
        state = reduceRelationshipField(state, action);
        

        // Enable menu accordions when accordions are fixed
        // state = {
        //     ...state,
        //     menu: reduceMenu(state.menu, action, state),
        // };

        forOwn(reducers, (reducer, key) => {
            state[key] = reducer(state[key], action);
        });

        state = reduceRouter(state, action);

        state = modify(state, "ui", (loadedModels) => reduceFilteredViewsRoute(loadedModels, action, state) )



        // const stateDiff = diff(previousState, state);
        // if(stateDiff) {
        //     console.log('state changed with '+action.name, stateDiff);
        // }


        // modify(window, '_actions', (actions) => {
        //     return [...actions, action];
        // }, []);
        // set(window, '_state', state);

        // let t2 = performance.now();
        // console.log("[OK]  "+action.type+" took " + (t2 - t1) + " milliseconds.");
        // console.log('[OK]', state);


        return state;
    }
}